import { FC, memo } from 'react'
import type { Props } from '../../types'

const ChevronDown: FC<Props> = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 10 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.828125 0.21875L9.82813 0.21875L5.32813 4.71875L0.828125 0.21875Z"
      fill="currentColor"
    />
  </svg>
)

export default memo(ChevronDown)
